'use strict';

/* global $ history */

export default function errorMsg (httpcode, el) {
    let msg = '';
    if ([401].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Ce formulaire est actuellement indisponible.<br>Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    if ([404].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Ce formulaire est actuellement indisponible.<br>Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    if ([400, 405, 406, 411, 412, 413, 414, 415, 416, 417].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Suite à un problème technique, nous n’avons pas pu enregistrer votre demande. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    if ([422].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Suite à un problème technique, nous n’avons pas pu enregistrer votre demande. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    if ([500, 502, 503, 504].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Ce formulaire est actuellement indisponible. Veuillez réessayer ultérieurement ou nous contacter par téléphone au 09 74 77 00 90 (prix d\'un appel local) ou par mail <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    if (['timeout'].includes(httpcode)) {
        msg = '<div class="msg-error"><div class="msg-error-box">Ce formulaire est actuellement indisponible. Veuillez réessayer ultérieurement ou nous contacter directement par téléphone au 09 74 77 00 90 (prix d’un appel local) ou par mail sur <a href="mailto:conseil@itg.fr">conseil@itg.fr</a>.</div></div>';
    }
    el.innerHTML = msg;
};



// WEBPACK FOOTER //
// ./front/js/modules/errorMsg.js